// Aloha is fixing their types
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Alohomora } from "@vitalsource/alohomorajs";
import { makeUrlSearchParams } from "../../../common/utils/object.ts";

// This is a function instead of a const so that we are retrieving redirect_uri
// at the point of call, not setting it to a fixed value
function getBaseAlohaParams() {
  return {
    dev: import.meta.env.VITE_ALOHA_DEV === "true",
    brand: window.location.hostname,
    context: "bookshelf",
    method: "universal",
    auth_host: window.location.host,
    auth_protocol: window.location.protocol,
    redirect_uri: window.location.href,
  };
}

export default function doLogin() {
  // Aloha is fixing their types
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  new Alohomora({
    ...getBaseAlohaParams(),
    ux_mode: "redirect",
  });
}

export function getAccessToken() {
  return new URLSearchParams(
    window.location.search + import.meta.env.VITE_DECIMAL_PATH
  ).get("access_token");
}

export function getAlohaParams() {
  return makeUrlSearchParams(getBaseAlohaParams());
}

export function getAlohaUrl(destination: string) {
  const params = getAlohaParams();
  return `https://${
    import.meta.env.VITE_ALOHA_HOST
  }${destination}?${params.toString()}`;
}
